import { onMounted, onBeforeUnmount } from 'vue';

/**
 * Global registry of dirty-state checkers for currently open form modals.
 * The global router guard consults this to decide whether to show a warning.
 */
const _checkers = new Set();

export function hasAnyFormModalDirty() {
    for (const fn of _checkers) {
        if (fn()) return true;
    }
    return false;
}

/**
 * Register a dirty-state checker for the current modal form component.
 * Automatically unregisters when the component unmounts.
 *
 * @param {() => boolean} isDirty  Returns true when the form has unsaved changes.
 */
export function useModalDirty(isDirty) {
    onMounted(() => _checkers.add(isDirty));
    onBeforeUnmount(() => _checkers.delete(isDirty));
}
